require('../modules/web.immediate');
module.exports = require('../modules/_core').setImmediate;



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/core-js/library/fn/set-immediate.js
// module id = ../../../node_modules/core-js/library/fn/set-immediate.js
// module chunks = 0